<template>
  <div class="IndexTow Pt75">
    <div class="box">
      <div class="PubTitle center">
        <h2>行业应用</h2>
      </div>
    </div>
    <div class="Click">
      <div class="box">
        <div class="flex">
          <!-- 动态生成选项卡 -->
          <p
            v-for="(item, index) in industryTabs"
            :key="index"
            :class="{ Active: activeIndexTwoTab === index }"
            @click="setActiveIndexTwoTab(index)">
            {{ item.title }}
          </p>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="ClickShow postion">
        <!-- 动态生成内容 -->
        <div
          v-for="(item, index) in industryTabs"
          :key="index"
          class="One"
          :class="{ Active: activeIndexTwoTab === index }">
          <div class="flex between wrap-flex-wrap">
            <div class="PubWord">
              <h1>{{ item.content.title }}</h1>
              <h2>{{ item.content.subtitle }}</h2>
              <p>{{ item.content.description }}</p>
              <div class="flex between">
                <dl> <dt>典型湿度需求</dt> <dd>{{ item.content.humidity }}</dd> </dl>
                <dl> <dt>温度范围</dt> <dd>{{ item.content.temperature }}</dd> </dl>
              </div>
            </div>
            <div class="Img">
              <dl>
                <dt><img :src="item.content.imageUrl" class="w100" alt=""/></dt>
                <dd>
                  <em><img src="/images/u438.svg" alt=""/></em>
                  <div>
                    <h2>{{ item.content.spokesperson }}</h2>
                    <p v-for="(paragraph, pIndex) in item.content.testimonial" :key="pIndex">{{ paragraph }}</p>
                  </div>
                  <em><img src="/images/u437.svg" alt=""/></em>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
<!--      <div class="Line postion">
        &lt;!&ndash; 动态生成进度条标签 &ndash;&gt;
        <dl
          v-for="(benefit, index) in benefits"
          :key="index"
          :class="{ Active: activeIndexTwoTab >= index }">
          <dt>
            <img :src="benefit.iconUrl" alt=""/>
            <em>{{ benefit.label }}</em>
          </dt>
        </dl>
      </div>-->
    </div>
  </div>
</template>

<script>
import { getIndustryApplication, getApplicationBenefit } from '@/api/request.js';

export default {
  name: 'SolutionIndex',
  data() {
    return {
      activeIndexTwoTab: 0,
      // 行业应用场景数据
      industryTabs: [],
      // 解决方案优势数据
      benefits: [],
      // 加载状态
      loading: false
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    setActiveIndexTwoTab(index) {
      this.activeIndexTwoTab = index;
    },
    async fetchData() {
      this.loading = true;
      try {
        // 并行调用两个API
        const [industryData, benefitData] = await Promise.all([
          getIndustryApplication(),
          getApplicationBenefit()
        ]);

        // 处理行业应用数据
        if (industryData && industryData.list) {
          this.industryTabs = industryData.list.map(item => ({
            title: item.title,
            content: {
              title: item.title,
              subtitle: item.subtitle,
              description: item.description,
              humidity: item.humidity_range,
              temperature: item.temperature_range,
              imageUrl: item.image_path,
              spokesperson: item.spokesperson,
              testimonial: this.parseTestimonials(item.testimonials)
            }
          }));
        }

        // 处理应用优势数据
        if (benefitData && benefitData.list) {
          this.benefits = benefitData.list.map(item => ({
            label: item.label,
            iconUrl: item.icon_url
          }));
        }

      } catch (error) {
        console.error('获取数据失败:', error);
        // 如果API调用失败，使用默认数据作为后备
        this.loadFallbackData();
      } finally {
        this.loading = false;
      }
    },

    // 解析testimonials JSON字符串
    parseTestimonials(testimonials) {
      try {
        let parsed = testimonials;

        // 如果是字符串，先解析JSON
        if (typeof testimonials === 'string') {
          parsed = JSON.parse(testimonials);
        }

        // 如果是数组
        if (Array.isArray(parsed)) {
          return parsed.map(item => {
            // 如果是对象且有quote字段，返回quote
            if (typeof item === 'object' && item !== null && item.quote) {
              return item.quote;
            }
            // 如果是字符串，直接返回
            if (typeof item === 'string') {
              return item;
            }
            // 其他情况转为字符串
            return String(item);
          });
        }

        // 如果是单个对象且有quote字段
        if (typeof parsed === 'object' && parsed !== null && parsed.quote) {
          return [parsed.quote];
        }

        // 其他情况
        return [String(parsed || '')];
      } catch (error) {
        console.warn('解析testimonials失败:', error, testimonials);
        // 如果解析失败，尝试直接使用原始数据
        return [String(testimonials || '')];
      }
    },

    // 后备数据（原静态数据）
    loadFallbackData() {
      this.industryTabs = [
        {
          title: '车间厂房',
          content: {
            title: '车间厂房',
            subtitle: '工业生产环境',
            description: '车间厂房内湿度控制对产品质量至关重要。过高或过低的湿度都可能影响生产设备的正常运行和产品的质量稳定性。',
            humidity: '40% - 60% RH',
            temperature: '20°C - 30°C',
            imageUrl: '/wimages/product/吊装机_06_网页.jpg',
            spokesperson: '工厂经理：',
            testimonial: [
              '我们的生产线经常因为湿度过高导致设备故障率上升，产品合格率下降。我们需要一个稳定的湿度控制系统来保证生产的连续性和产品质量。'
            ]
          }
        },
        {
          title: '锂电池车间',
          content: {
            title: '锂电池车间',
            subtitle: '精密制造环境',
            description: '锂电池生产车间对湿度有极高的要求。湿度过高可能导致电池内部短路，而湿度过低则可能产生静电，损害电池安全性和性能。',
            humidity: '≤ 1% RH',
            temperature: '20°C - 25°C',
            imageUrl: '/wimages/product/吊装机_06_网页.jpg',
            spokesperson: '工艺工程师：',
            testimonial: [
              '我们生产的锂电池需要在非常严格的湿度条件下组装，否则会影响电池的寿命和安全性。目前使用的除湿系统无法满足我们的高精度要求，我们需要更专业的解决方案。'
            ]
          }
        },
        {
          title: '物流仓储',
          content: {
            title: '物流仓储',
            subtitle: '货物存储环境',
            description: '物流仓储环境中，湿度过高可能导致货物受潮、霉变或腐蚀，而湿度过低可能导致某些材料干裂或静电积聚，影响货物的安全存储。',
            humidity: '50% - 70% RH',
            temperature: '15°C - 30°C',
            imageUrl: '/wimages/product/吊装机_06_网页.jpg',
            spokesperson: '仓库主管：',
            testimonial: [
              '我们的仓库经常遇到货物受潮的问题，尤其是在梅雨季节，这给公司带来了不小的损失。我们需要一套可靠的湿度监控和调节系统来保护我们的库存商品。'
            ]
          }
        },
        {
          title: '地下车库',
          content: {
            title: '地下车库',
            subtitle: '封闭空间环境',
            description: '地下车库由于其封闭特性，通常通风不良，容易造成湿气积聚，导致墙面发霉、车辆生锈等问题，需要有效的湿度控制方案。',
            humidity: '≤ 70% RH',
            temperature: '10°C - 25°C',
            imageUrl: '/wimages/product/吊装机_06_网页.jpg',
            spokesperson: '物业经理：',
            testimonial: [
              '我们的地下车库经常出现墙壁发霉和地面潮湿的问题，这影响了车库的使用体验和安全性。我们需要一种经济高效的湿度控制方案来改善地下车库的环境条件。'
            ]
          }
        }
      ];

      this.benefits = [
        {
          label: '防潮',
          iconUrl: '/images/u555.svg'
        },
        {
          label: '防静电',
          iconUrl: '/images/u559.svg'
        },
        {
          label: '防腐蚀',
          iconUrl: '/images/u565.svg'
        },
        {
          label: '智能控制',
          iconUrl: '/images/u570.svg'
        }
      ];
    }
  }
};
</script>

<style scoped lang="less">
/* Add any specific styles for IndexTow if needed */
.Img {
  .w100 {
    width: 100%;
    //height: 15.25rem;
  }
}

.One {
  width: 100%;
}
</style>